var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { TestingService } from '@/services';
import { closeLoading, showLoading, useUI } from '@/store';
import { getLocalStorage, timeZoneName, timeZoneUTC } from '@/utils';
export const ToolsContext = createContext(undefined);
export const ToolsProvider = ({ children }) => {
    const [status, setStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const uiCTX = useUI();
    const info = useMemo(() => {
        var _a;
        const uMotifCode = (_a = getLocalStorage().umotif_code) !== null && _a !== void 0 ? _a : '';
        const timeZone = `${timeZoneName()} (${timeZoneUTC()})`;
        return {
            timeZone,
            uMotifCode
        };
    }, []);
    const fetchStatus = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const statusData = yield TestingService.getTimeWarpStatus();
            setStatus(statusData);
        }
        catch (err) {
            console.error('Failed to load Time Warp status:', err);
        }
        finally {
            setIsLoading(false);
        }
    });
    useEffect(() => {
        uiCTX.dispatch(isLoading ? showLoading() : closeLoading());
    }, [isLoading]);
    useEffect(() => {
        fetchStatus();
    }, []);
    return (_jsx(ToolsContext.Provider, Object.assign({ value: {
            fetchStatus,
            info,
            isLoading,
            setIsLoading,
            status
        } }, { children: children })));
};
export const useTools = () => {
    const context = useContext(ToolsContext);
    if (context === undefined) {
        throw new Error('useTools must be used within a ToolsProvider');
    }
    return context;
};
